import { immer } from 'zustand/middleware/immer'
import { devtools, subscribeWithSelector } from 'zustand/middleware'
import { TrillionViewerSlice, createTrillionViewerSlice } from './TrillionViewerSlice'
import { createContext, useContext } from 'react'
import { createStore, useStore } from 'zustand'

export function createZustandStore() {
  return createStore<TrillionViewerSlice>()(
    subscribeWithSelector(
      immer(
        devtools(
          (...a) => ({
            ...createTrillionViewerSlice(...a),
          }),
          { name: 'trillion-viewer-store' },
        ),
      ),
    ),
  )
}

export type StoreScheme = ReturnType<typeof createZustandStore>

export const StoreContext = createContext<StoreScheme>(createZustandStore())

type ExtractState<S> = S extends {
  getState: () => infer T
}
  ? T
  : never

export const useAppStore = <U,>(selector: (state: ExtractState<StoreScheme>) => U) =>
  useStore(useContext(StoreContext), selector)
